import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updateCarKilometer } from "../../../redux/car/car-kilometer-slice";



const EditKilometer = ({ car, closeButtomSheetHandler }) => {
  const dispatch = useDispatch();
  const [kilometer, setKilometer] = useState(""); // مقدار واقعی (فقط عدد)
  const [displayValue, setDisplayValue] = useState(""); // مقدار قابل نمایش در input

  // 🧠 تابع تبدیل اعداد فارسی به انگلیسی
  const toEnglishDigits = (str) =>
    str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  // 🎯 مقدار اولیه هنگام دریافت prop car
  useEffect(() => {
    if (car?.kilometer != null) {
      const clean = toEnglishDigits(String(car.kilometer)).replace(/[^\d]/g, "");
      setKilometer(clean);
      setDisplayValue(clean ? Number(clean).toLocaleString("fa-IR") : "");
    }
  }, [car]);

  // ⚡ تغییر مقدار هنگام تایپ
  const handleChange = (e) => {
    const raw = toEnglishDigits(e.target.value).replace(/[^\d]/g, "");
    setKilometer(raw);
    setDisplayValue(raw); // در حین تایپ، بدون فرمت
  };

  // 🪄 فرمت مقدار هنگام خروج از فیلد
  const handleBlur = () => {
    if (kilometer) setDisplayValue(Number(kilometer).toLocaleString("fa-IR"));
  };

  // 📩 پیام Toast
  const showMessage = (msg, type = "success") => {
    toast[type](msg, {
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  // 🚗 بروزرسانی کیلومتر در سرور
  const updateKilometerHandler = async () => {
    if (!kilometer) {
      showMessage("لطفاً مقدار کیلومتر را وارد کنید", "warn");
      return;
    }
    // (اختیاری) کنترل سقف غیرمنطقی
    if (kilometer > 1000000000) {
      showMessage("افزایش کیلومتر بیش از حد مجاز است!", "warn");
      return;
    }

    try {
      const resultAction = await dispatch(updateCarKilometer({ id: car.id, kilometer: Number(kilometer) }));
      if (updateCarKilometer.fulfilled.match(resultAction)) {
        toast.success("کیلومتر با موفقیت بروزرسانی شد ✅");
        closeButtomSheetHandler();
      } else {
        toast.warn(resultAction.payload || "خطا در بروزرسانی کیلومتر");
      }
    } catch (err) {
      console.log(err);
      toast.error("عملیات ناموفق بود ❌");
    }
    // const formData = new FormData();
    // formData.append("kilometer", Number(kilometer));
    // api.put(`${UPDATE_KILOMETER}/${car.id}`, formData)
    // .then((res) => {
    //       if (res.data.isSuccess) {

    //         showMessage(res.data.message,'success');
    //         closeButtomSheetHandler();
    //       } else {
    //         showMessage(res.data.message,'warn');
    //       }
    //   });
  };

  const handleClose = () => {
    closeButtomSheetHandler();
  };

  // 🧩 رابط کاربری
  return (
    <div className="px-3 py-2">
      <small className="text-muted d-block mb-2 text-center">
        بروزرسانی کیلومتر خودرو{" "}
        <strong className="text-dark">{car.title}</strong>
      </small>

      <div className="form-floating mb-3">
        <input
          id="kilometer"
          type="text"
          inputMode="numeric"
          className="form-control form-control-sm rounded-3"
          placeholder="کیلومتر فعلی"
          // value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <label htmlFor="kilometer">کیلومتر فعلی (km)</label>
      </div>

      <div className="d-flex gap-2">
        <button
          onClick={updateKilometerHandler}
          className="btn btn-success btn-sm flex-fill"
          type="button"
        >
          تأیید
        </button>
        <button
          onClick={handleClose}
          className="btn btn-outline-danger btn-sm flex-fill"
          type="button"
        >
          انصراف
        </button>
      </div>

      <p className="text-muted text-center small mt-2">
        مقدار فعلی: {car.kilometer}
      </p>
      {/* <p className="text-muted text-center small mt-2">
        مقدار واقعی ذخیره شده: {displayValue}
      </p> */}
    </div>
  );
};

export default EditKilometer;
